module.exports = __webpack_public_path__ + "static/media/22ESCWA1.bc9905e5.jpg";